/**
 * Small pill-button toggle for choosing US gallons vs litres.
 */
import type { VolumeUnit } from '@reefapp/shared';

interface UnitsToggleProps {
  unit: VolumeUnit;
  onChange(u: VolumeUnit): void;
}

export function UnitsToggle({ unit, onChange }: UnitsToggleProps) {
  return (
    <div className="inline-flex rounded-md overflow-hidden border border-slate-600">
      <button
        type="button"
        onClick={() => onChange('gal')}
        className={`px-3 py-1 text-xs font-semibold transition-colors ${
          unit === 'gal'
            ? 'bg-cyan-700 text-white'
            : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
        }`}
      >
        US gal
      </button>
      <button
        type="button"
        onClick={() => onChange('L')}
        className={`px-3 py-1 text-xs font-semibold transition-colors ${
          unit === 'L'
            ? 'bg-cyan-700 text-white'
            : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
        }`}
      >
        L
      </button>
    </div>
  );
}
